import { render, staticRenderFns } from "./LogsPagination.vue?vue&type=template&id=af06a41c"
import script from "./LogsPagination.vue?vue&type=script&lang=js"
export * from "./LogsPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports